import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import { generateId } from './../../ricos-content';
import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { CaptionNode } from './../../ricos-types';
import { captionDefaultAttributes } from './../../_shared/figure/consts';

export const captionConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.CAPTION],
    // @ts-ignore $TSFixMe
    convert: (node: CaptionNode, visit: (node: CaptionNode) => PmNodeJson[]) => {
      const { style, captionData } = node || {};

      return {
        type: Node_Type.CAPTION,
        attrs: {
          ...captionData,
          ...(style ? { style } : {}),
          id: node.id ?? generateId(),
        },
        content: visit(node),
      };
    },
  },
  fromPm: {
    types: [Node_Type.CAPTION],
    // @ts-ignore $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { id, style, dir: _, textStyle } = node.attrs || {};

      const transformedStyle = {
        paddingBottom: excludeDefaultValue(
          style?.paddingBottom,
          captionDefaultAttributes.styleDefaults.paddingBottom
        ),
        paddingTop: excludeDefaultValue(
          style?.paddingTop,
          captionDefaultAttributes.styleDefaults.paddingTop
        ),
      };

      const transformedTextStyle = {
        textAlignment: excludeDefaultValue(
          textStyle?.textAlignment,
          captionDefaultAttributes.textStyle.textAlignment
        ),
        lineHeight: excludeDefaultValue(
          textStyle?.lineHeight,
          captionDefaultAttributes.textStyle.lineHeight
        ),
      };

      return {
        type: Node_Type.CAPTION,
        id,
        nodes: visit(node),
        ...(Object.values(transformedStyle).some(v => v !== undefined) && {
          style: transformedStyle,
        }),
        ...(Object.values(transformedTextStyle).some(v => v !== undefined) && {
          captionData: { textStyle: transformedTextStyle },
        }),
      };
    },
  },
};

export const createCaptionTiptapNode = (content?: PmNodeJson[]) => {
  return {
    type: Node_Type.CAPTION,
    attrs: {
      id: generateId(),
    },
    content: content ?? [],
  };
};

function excludeDefaultValue<T extends string | number>(value: T, defaultValue: T) {
  return value === defaultValue ? undefined : value;
}
